import "./style.scss";

export const Loading = ({ classes }: { classes?: string }) => {
  return (
    <div className={`snippet ${classes}`} data-title="dot-flashing">
      <div className="stage">
        <div className="dot-flashing"></div>
      </div>
    </div>
  );
};
